import type { CalendarTheme } from "rn-calendar-component";

import { isNative } from "@stepapp/core";
import { palette, spacing, typographyVariants } from "@stepapp/ui";

const calendarTheme: CalendarTheme = {
  day: {
    container: {
      alignItems: "center",
      justifyContent: "center",
      borderRadius: spacing.unit * 2.5,
      height: spacing.unit * 5,
      width: spacing.unit * 5,
    },
    text: {
      ...typographyVariants.body,
      color: `${palette.font.secondary}66`,
    },
    pastDayText: {
      color: palette.common.disabled,
      textDecorationLine: "line-through",
    },
  },
  dayNames: {
    container: {
      borderBottomColor: palette.common.lightGray,
      borderBottomWidth: spacing.border,
      height: spacing.unit * 5,
      alignItems: "center",
    },
    text: {
      ...(isNative ? typographyVariants.lightLabel : typographyVariants.paragraph),
      color: palette.font.secondary,
    },
  },
  monthTitle: {
    container: {
      height: spacing.unit * 6,
      paddingHorizontal: spacing.unit,
      alignItems: "center",
      justifyContent: "center",
    },
  },
};

export default calendarTheme;
